import { PopoverPortalContext } from "@circle-react-shared/uikit/PopoverPortal";
import { Bookmarks as BookmarksPanel } from "@circle-react/components/Bookmarks";
import { Popover as CompassPopover } from "@circleco/compass/components/Popover";
import { Typography } from "@circleco/compass/components/Typography";
import { useMemo, useState } from "react";

import { t } from "@/i18n-js/instance";
import { classNames } from "@/react/helpers/twMergeWithCN";

import { HeaderIconButton } from "./HeaderIconButton";

export const Bookmarks = () => {
  const [isOpen, setIsOpen] = useState(false);
  const popoverPortalContextValue = useMemo(
    () => ({ onClose: () => setIsOpen(false) }),
    [],
  );

  return (
    <CompassPopover
      trigger={
        <HeaderIconButton
          icon="bookmark"
          ariaLabel={t("header_v3.bookmarks")}
          hotkey="alt+b"
          isOpen={isOpen}
          data-testid="bookmarks-popover-button"
        />
      }
      open={isOpen}
      onOpenChange={setIsOpen}
      side="bottom"
      align="end"
      sideOffset={4}
      fillAvailableHeight
      className={classNames("max-h-[37rem] w-[38.5rem] p-0")}
    >
      <PopoverPortalContext.Provider value={popoverPortalContextValue}>
        <div
          className="flex size-full flex-col gap-3"
          data-testid="bookmarks-drawer"
        >
          <div className="flex shrink-0 items-center justify-between px-6 pt-5">
            <Typography variant="heading-lg">
              {t("header_v3.bookmarks")}
            </Typography>
          </div>
          <BookmarksPanel />
        </div>
      </PopoverPortalContext.Provider>
    </CompassPopover>
  );
};
